import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { PaymentLayoutActions, PaymentLayoutActionTypes } from './../actions/payment-layout.action';
import { Customer } from './../../models/customer';

export interface State extends EntityState<Customer> { }

const adapter: EntityAdapter<Customer> = createEntityAdapter<Customer>({
    selectId: (customer: Customer) => customer.customerCode,
    sortComparer: false
});

const initialState: State = adapter.getInitialState();

export function reducer(state = initialState, action: PaymentLayoutActions): State {
    switch (action.type) {
        case PaymentLayoutActionTypes.CLEAR_CUSTOMERS: {
            return initialState;
        }

        case PaymentLayoutActionTypes.LOAD_CUSTOMERS_SUCCESS: {
            return adapter.addMany(action.payload, state);
        }

        case PaymentLayoutActionTypes.ADD_CUSTOMER: {
            return adapter.addOne(action.payload, state);
        }

        default: {
            return state;
        }
    }
}

export const getCustomers = (state: State) => state && state.entities;
